import { httpCreate } from './http';

const http = httpCreate('/shop/api/shippingSite');

export const shippingSite = {
	updateUserAddress(userId, body) {
		return http.post(`/userAddress/${userId}`, body);
	},
	getUserAddress(userId) {
		return http.get(`/userAddress/${userId}`);
	},
};
